<template>
  <div>
    <ImageHeader :name="name" :imageId="imageId" />
    <v-container fluid>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import ImageHeader from "@/modules/images/components/ImageHeader";
export default {
  components: {
    ImageHeader,
  },
  computed: {
    name() {
      const active = this.$store.getters["ImageStore/cache"];
      if (active.name) {
        return active.name;
      }
      return "";
    },
    imageId() {
      return this.$store.getters["ImageStore/id"];
    },
  },
  mounted() {
    var imageId = this.$route.params.id;
    this.$store.dispatch("ImageStore/getOneImage", imageId).catch((err) => this.$root.$error(err));
  },
};
</script>
